import { ObjectsHelper } from '../../helpers/object-helper';
import { ControlType } from '../control-type/control-type.model';
import { IRestrictedAccountObjectArgs, RestrictedAccountObject } from '../restricted-account-object/restricted-account-object.model';
import { ControlConfig, ControlConfigDirection } from './control-config.model';

export interface IControlArgs extends IRestrictedAccountObjectArgs {
    controlType: string | ControlType;
    name?: string;
    title?: string;
    sequence?: number;
    description?: string;
    descriptionImage?: string;
    defaultValue?: string | number | object;
    config?: ControlConfig;
    group?: string;
    validators?: Array<string>;
    linkable?: boolean;
}

const defaults = {
    name: '',
    title: '',
    sequence: 0,
    description: '',
    descriptionImage: '',
    defaultValue: '',
    config: {
        showLabel: true,
        direction: ControlConfigDirection.ROW
    },
    controlType: '',
    group: '',
    validators: [],
    linkable: false
} as IControlArgs;

abstract class AbstractControl extends RestrictedAccountObject {
    name: string;
    title: string;
    sequence: number;
    description: string;
    descriptionImage: string;
    defaultValue: string | number | object;
    config: ControlConfig;
    controlType: string | ControlType;
    group: string;
    validators: Array<string>;
    linkable: boolean;

    constructor(data?: IControlArgs) {
        super({
            ...data,
            config: ObjectsHelper.parseJsonField(data.config, data.config, data, 'config'),
            defaultValue: ObjectsHelper.parseJsonField(data.defaultValue, data.defaultValue, data, 'defaultValue')
        });
    }
}

export class Control extends AbstractControl {
    controlType: string;

    constructor(data?: IControlArgs) {
        super({...defaults, ...data}  as any);
    }
}

export interface IControlInlinedArgs extends IControlArgs {
    controlType: ControlType;
}

export class ControlInlined extends AbstractControl {
    controlType: ControlType;

    constructor(data?: IControlInlinedArgs) {
        super({...defaults, ...data}  as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control/control.model.ts